<template>
  <div id="Product">
    <div class="banner">
      <img src="/static/images/product/m_pd_bg.png" alt="">
      <div class="con">
        <div class="bannerText">Lettuce Software</div>
        <div class="conBox" v-for="(item,index) in list" :key="index">
          <div class="imgBox">
            <img :src="item.src" alt="">
          </div>
          <div class="proInfo">
            <div class="proName">{{item.proName}}</div>
            <div class="proDetail">{{item.proDetail}}</div>
            <div class="proPrice">
              <div>
                <span class="price">Price: ₱ {{item.price}}</span>
              </div>
              <div class="servceFree" v-if="item.servicePrice">
                <span class="price">Service fee：₱ {{item.servicePrice}}/Month</span>
              </div>
            </div>
          </div>
          <!-- <div class="proBtn">
            <span class="Btn">{{item.proBtn}}</span>
          </div> -->
        </div>
      </div>
    </div>
    <div class="content">
        <div class="con">
          <div class="title">Hardware cost</div>
          <div class="productBox">
            <div class="proList"  v-for="(item,index) in proList" :key="index">
              <div class="proImg"><img :src="item.src" alt=""></div>
              <div class="proCon">
                <div class="proName">{{item.proName}}</div>
                <div class="proDetail">{{item.proDetail}}</div>
                <div class="proPrice">
                  <span class="price">{{item.price}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list:[
        {
          src:'/static/images/product/pd_pos.png',
          proName:'Cashier POS',
          proDetail:'Frequently asked questions about catering software for everyday use',
          price:'25000.00',
          servicePrice:'1000.00',
        },
        {
         src:'/static/images/product/pd_ipad.png',
          proName:'Take Order Machine',
          proDetail:'Frequently asked questions about catering software for everyday use',
          price:'15000.00',
          servicePrice:'1000.00',
        },
        {
         src:'/static/images/product/pd_web.png',
          proName:'Take Order Machine',
          proDetail:'Business data online viewing, quick configuration of store information',
          price:'50000.00',
          servicePrice:'',
        }
      ],
        proList:[
        {
          src:'/static/images/product/pd_a.png',
          proName:'Cashier POS',
          proDetail:'Frequently asked questions about catering software for everyday use',
          price:'₱ 1680.00',
          unit:'P/Month'
        },
        {
         src:'/static/images/product/pd_b.png',
          proName:'Cashier POS',
          proDetail:'Frequently asked questions about catering software for everyday use',
          price:'₱ 1680.00',
          unit:'P/Month'
        },
        {
         src:'/static/images/product/pd_c.png',
          proName:'Cashier POS',
          proDetail:'Frequently asked questions about catering software for everyday use',
          price:'₱ 1680.00',
          unit:'P/Month'
        },
        {
         src:'/static/images/product/pd_d.png',
          proName:'Cashier POS',
          proDetail:'Frequently asked questions about catering software for everyday use',
          price:'₱ 1680.00',
          unit:'P/Month'
        },
        {
         src:'/static/images/product/pd_e.png',
          proName:'Cashier POS',
          proDetail:'Frequently asked questions about catering software for everyday use',
          price:'₱ 1680.00',
          unit:'P/Month'
        },
        {
         src:'/static/images/product/pd_f.png',
          proName:'Cashier POS',
          proDetail:'Frequently asked questions about catering software for everyday use',
          price:'₱ 1680.00',
          unit:'P/Month'
        },
      ],
      selectId:0
    };
  },
  //定义这个sweiper对象
  computed: {},
  created:function () {
    window.scroll(0, 0);
    this.$emit('menuHiddens');
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
    if (this.$getCookie("langs") == "en") {
      this.lang_en = true;
    } else {
      this.lang_en = false;
    }
    this.show=true
  },
  methods: {
    clickList(id){
      this.selectId = id
    },
  }
};
</script>
<style scoped lang="less" type="text/less">
#Product{
  margin-top: 50px;
  .banner{
    position: relative;
    img{
      width: 100%;
    }
    .con{
      position: absolute;
      width: 80%;
      top: 5%;
      left: 0;
      right: 0;
      margin: auto;
      text-align: center;
      .bannerText{
        text-align: center;
        color: #333;
        font-size: 3rem;
        font-weight: bold;
      }
      .conBox{
        &:nth-child(2){
          padding-bottom: 0;
        }
        .imgBox{
          img{
            width: 70%;
          }
        }
        .proInfo{
          position:relative;
          top: -1rem;
          .proName{
            color: #333;
            font-size: 2.4rem;
            font-weight: bold;
          }
          .proDetail{
            padding: 15px 0;
            font-size: 1.8rem;
            color: #999;
          }
          .proPrice{
            position: relative;
            .price{
              font-size: 2.4rem;
              font-weight: bold;
              color: #FF9703;
            }
            .unit{
              font-size: 1.4rem;
              font-weight: bold;
              color: #FF9703;
            }
            .servceFree{
              .price{
                font-size: 1.8rem;
                font-weight: bold;
                color: #25B7AA;
              }
              .unit{
                font-size: 1.2rem;
                font-weight: bold;
                color: #25B7AA;
              }
            }
          }
          }
        }

      .proBtn{
        margin-top: 2rem;
        .Btn{
          background:rgba(39,194,180,1);
          box-shadow:0px 3px 6px rgba(11,128,117,0.26);
          border-radius:18px;
          display: inline-block;
          padding: 8px 25px;
          color: #fff;
          cursor: pointer;
        }
      }

    }
  }
  .content{
    padding: 60px 0;
    .con{
      width: 80%;
      margin: 0 auto;
      .title{
        color: #333;
        font-size: 24px;
        font-weight: bold;
        text-align: center;
        padding:0 0 50px 0;
      }
      .productBox{
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-wrap: wrap;
        .proList{
          width: 100%;
          margin: 0 auto 20px auto;
          border: 1px solid #d6d6d6;
          &:nth-child(3n){
            margin-right: 0;
          }
          .proImg{
            img{
              width: 100%;
            }
          }
          .proCon{
            padding: 20px;
            .proName{
              font-size: 2rem;
              color: #333;
              font-weight: bold;
            }
            .proDetail{
              color: #999;
              font-size: 1.4rem;
              padding: 10px 0;
            }
            .proPrice{
              position: relative;
              .price{
                color: #FF9703;
                font-size: 2rem;
                font-weight: bold;
              }
              .proBtn{
                background:rgba(39,194,180,1);
                box-shadow:0px 3px 6px rgba(11,128,117,0.26);
                border-radius:18px;
                display: inline-block;
                padding: 8px 15px;
                color: #fff;
                font-size: 1.4rem;
                position:absolute;
                right: 0;
                top: 15px;
                cursor: pointer;
              }

            }
          }
        }
      }

    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/Product/Product.vue